import { __ } from '../../../Utils';
import BaseList from '../../ProductCatalog/BaseList';

class BaseMarketingLayout extends BaseList {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      checkedFilter: [],
      defaultFilter: [],
      doNotLoadFilters: false,
      buttonsSwitch: [
        {
          label: __('Marketingové materiály'),
          url: './materials',
          rolesExcluded: [],
        },
        {
          label: __('Grafika'),
          url: './graphic',
          rolesExcluded: [],
        },
        {
          label: __('Tlačoviny'),
          url: './prints',
          rolesExcluded: [],
        },
        {
          label: __('Videá'),
          url: './videos',
          rolesExcluded: [],
        },
        {
          label: __('Fotobanka'),
          url: './photos',
          rolesExcluded: [],
        },
      ],
      actualPage: 1,
      limit: 25,
      offset: 0,
      previousLevel: 0,
      loading: true,
      items: [],
      tableItems: [],
      filters: [],
      notFoundMessage: '',
      defaultSearchText: '',
    };
  }

  render() {
    return super.render();
  }
}

export default BaseMarketingLayout;



// WEBPACK FOOTER //
// ./src/Containers/Marketing/BaseList/index.jsx